module.exports = __webpack_public_path__ + "img/4.ee293222.jpg";